'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var NumberType = /* @__PURE__ */ ((NumberType2) => {
  NumberType2["standard"] = "standard";
  NumberType2["percent"] = "percent";
  return NumberType2;
})(NumberType || {});
var NumberCounterLayout = /* @__PURE__ */ ((NumberCounterLayout2) => {
  NumberCounterLayout2["number"] = "number";
  NumberCounterLayout2["bar"] = "bar";
  NumberCounterLayout2["circle"] = "circle";
  return NumberCounterLayout2;
})(NumberCounterLayout || {});
var NumberPosition = /* @__PURE__ */ ((NumberPosition2) => {
  NumberPosition2["above"] = "above";
  NumberPosition2["inside"] = "inside";
  NumberPosition2["below"] = "below";
  NumberPosition2["hidden"] = "hidden";
  return NumberPosition2;
})(NumberPosition || {});

exports.NumberCounterLayout = NumberCounterLayout;
exports.NumberPosition = NumberPosition;
exports.NumberType = NumberType;
